import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import {
  defaultLanguage,
  availableLanguages,
  defaultCultureLanguage,
} from '../assets/i18n/languages';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslatorProvider {
  public dictionary: any;

  public isReady: boolean = false;

  private tranlatorLoadedSource = new Subject();

  get currentLanguage(): string {
    const browserLang = this.translate.getBrowserLang();
    const language = availableLanguages.some((x) => x.code == browserLang);
    if (language) {
      return this.translate.getBrowserCultureLang() || defaultCultureLanguage;
    }

    return defaultCultureLanguage;
  }

  getLanguageCode() {
    return this.currentLanguage.split('-')[0];
  }

  constructor(private translate: TranslateService) {
    let browserLang = this.translate.getBrowserLang();
    var language = availableLanguages.some((x) => x.code == browserLang)
      ? browserLang
      : defaultLanguage;

    this.translate.use(language!).subscribe((translations) => {
      this.dictionary = translations;
      this.isReady = true;
      this.tranlatorLoadedSource.next(null);
    });
  }
}
